'use client'

import Image from 'next/image'
import { useMapboxContext } from '@component/mapbox/map/context'
import useControl from '../useControl'
import IconSatelliteControl from '@image/satellite-control.jpg'
import classNames from 'classnames'


export default function SatelliteControl () {
  return useControl(<SatelliteControlContent></SatelliteControlContent>, {position: 'bottom-right', groupClass: false})
}
function SatelliteControlContent () {
  const { layerVisible, changeSatelliteLayerLinzVisible } = useMapboxContext()
  function toggleHandle () {
    changeSatelliteLayerLinzVisible(!layerVisible.satelliteLinz)
  }

  return (
    <div className='w-50 h-44 sm:w-70 sm:h-64 overflow-hidden rounded-sm cursor-pointer relative' onClick={toggleHandle}>
      <Image src={IconSatelliteControl} alt='satellite control' className={classNames({'-ml-70': layerVisible.satelliteLinz})} unoptimized></Image>
      <div className='absolute inset-x-0 inset-y-0 py-4 flex items-end justify-center text-white bg-image-mask-md text-xs sm:text-sm'>{layerVisible.satelliteLinz ? 'street' : 'satellite'}</div>
    </div>
  )
}